import * as Sentry from "@sentry/react";
import { coerceFiniteNumber } from "@opus-dt/shared-types";

export { coerceFiniteNumber };

export function coerceKpiNumber(value: unknown, context: string): number | null {
  const result = coerceFiniteNumber(value);
  if (result === null && value !== null && value !== undefined) {
    Sentry.captureMessage(`KPI numérico com tipo inesperado em ${context}`, {
      level: "warning",
      extra: { receivedType: typeof value },
    });
  }
  return result;
}
